// These four cutlines and cutoffs describe
// whether a student in k-3 is at risk of Dyslexia
const dyslexiaCutlines = [
  [
    {
       "id":"Risk Score_fall_0",
       "label":"High Risk",
       "value":30
    },
    {
       "id":"Risk Score_fall_0",
       "label":"High Risk (Stronger Signals)",
       "value":33
    }
  ],
  [
    {
       "id":"Risk Score_fall_1",
       "label":"High Risk",
       "value":30
    },
    {
       "id":"Risk Score_fall_1",
       "label":"High Risk (Stronger Signals)",
       "value":36
    }
  ],
  [
    {
       "id":"Risk Score_fall_2",
       "label":"High Risk",
       "value":30,
    },
    {
       "id":"Risk Score_fall_2",
       "label":"High Risk (Stronger Signals)",
       "value":36,
    }
  ],
  [
    {
       "id":"Risk Score_fall_3",
       "label":"High Risk",
       "value":30
    },
    {
       "id":"Risk Score_fall_3",
       "label":"High Risk (Stronger Signals)",
       "value":36
    }
  ],
  [
    {
       "id":"Risk Score_fall_4",
       "label":"High Risk",
       "value":30
    },
    {
       "id":"Risk Score_fall_4",
       "label":"High Risk (Stronger Signals)",
       "value":36
    }
  ],
  [
    {
       "id":"Risk Score_fall_5",
       "label":"High Risk",
       "value":30
    },
    {
       "id":"Risk Score_fall_5",
       "label":"High Risk (Stronger Signals)",
       "value":36
    }
  ],
];

const dyslexiaCutlinesDemo = [
  [
    {
       "id":"Risk Score_fall_0",
       "label":"High Risk",
       "value":25
    },
    {
       "id":"Risk Score_fall_0",
       "label":"High Risk (Stronger Signals)",
       "value":28
    }
  ],
  [
    {
       "id":"Risk Score_fall_1",
       "label":"High Risk",
       "value":25
    },
    {
       "id":"Risk Score_fall_1",
       "label":"High Risk (Stronger Signals)",
       "value":28
    }
  ],
  [
    {
       "id":"Risk Score_fall_2",
       "label":"High Risk",
       "value":25,
    },
    {
       "id":"Risk Score_fall_2",
       "label":"High Risk (Stronger Signals)",
       "value":28,
    }
  ],
  [
    {
       "id":"Risk Score_fall_3",
       "label":"High Risk",
       "value":25
    },
    {
       "id":"Risk Score_fall_3",
       "label":"High Risk (Stronger Signals)",
       "value":28
    }
  ],
  [
    {
       "id":"Risk Score_fall_4",
       "label":"High Risk",
       "value":25
    },
    {
       "id":"Risk Score_fall_4",
       "label":"High Risk (Stronger Signals)",
       "value":28
    }
  ],
  [
    {
       "id":"Risk Score_fall_5",
       "label":"High Risk",
       "value":25
    },
    {
       "id":"Risk Score_fall_5",
       "label":"High Risk (Stronger Signals)",
       "value":28
    }
  ],
];

export { dyslexiaCutlines, dyslexiaCutlinesDemo };